// components
import ComponentsRender from '@/components/ComponentsRender';

// constants
import { COMPONENTS } from '@/components/components';

const Block = ({ blockContent: content }) => {
  return (
    <div className="mx-auto my-10 w-[90vw] xl:w-(--container-width)">
      {(content || []).map((component) => (
        <ComponentsRender key={`${component.id}_${component.__typename}`} type={COMPONENTS} component={component} />
      ))}
    </div>
  );
};
export default Block;
